import {ImageEditor} from "../imageEditor";
import { ref, watch } from 'vue';
import _ from "lodash";

const states = [];
let maxStates = 9;
let currentState = 0;

let canSaveState = true;

let fieldsToWatch = [
    'mask_type',
    'bg_color',
    'text',
    'laminate',
    'width',
    'height',
    'quantity',
]

const debouncedFieldModified = _.debounce((field) => {
    window.imageEditor.saveState(field+' changed.');
}, 100);

const debouncedFieldModifiedLong = _.debounce((field) => {
    window.imageEditor.saveState(field+' changed.');
}, 600);

ImageEditor.prototype.init_changeHistory = function () {
    document.addEventListener("keydown", (event) => {
        if (event.ctrlKey && event.key === "z") {
            window.imageEditor.undo();
        }

        if (event.ctrlKey && event.shiftKey && event.key === "Z") {
            window.imageEditor.redo();
        }

        if (event.key === "F8") {
            window.imageEditor.saveState(`f8`);
        }
    });

    let canvas = window.imageEditor.store.canvas;

    canvas.on('object:added', function (e) {
        window.imageEditor.saveState(`object:added`);
    });
    canvas.on('object:removed', function (e) {
        window.imageEditor.saveState(`object:removed`);
    });
    canvas.on('object:modified', function (e) {
        window.imageEditor.saveState(`object:modified`);
    });

    fieldsToWatch.forEach((element) => {
        watch(() => this.store[element], (oldValue, newValue) => {
            if (element === 'bg_color') {
                debouncedFieldModifiedLong(element);
                return;
            }

            debouncedFieldModified(element);
        });
    });

    watch(() => this.store.maskData, (oldValue, newValue) => {
        debouncedFieldModified('maskData');
    }, {deep: true});

    refresh();
}

function refresh() {
    let store = window.imageEditor.store;

    store.canUndo = currentState > 1 && states.length > 1;

    store.canRedo = currentState < states.length;
}

ImageEditor.prototype.saveState = function(name) {
    if (!canSaveState) return;

    let state = {
        name: name,
        canvasData: JSON.stringify(this.store.canvas.toJSON()),
        store: {
            material_id: this.store.material_id,
            maskData: _.cloneDeep(this.store.maskData),
        },
    }

    fieldsToWatch.forEach((element) => {
        state.store[element] = this.store[element];
    });

    if (currentState < states.length) {
        states.splice(-(states.length - currentState));
    }

    states.push(state);

    if (states.length > maxStates) {
        states.splice(0, states.length - maxStates);
    }

    currentState = states.length;

    refresh();
}

ImageEditor.prototype.undo = function() {
    if (states.length <= 1) {
        return;
    }

    currentState --;
    currentState = Math.max(1, currentState);

    loadState({state: states[currentState-1]});
}

ImageEditor.prototype.redo = function() {
    if (states.length <= 1) {
        return;
    }

    currentState ++;
    currentState = Math.min(states.length, currentState);

    loadState({state: states[currentState-1]});
}

const debouncedCanSaveState = _.debounce(() => {
    canSaveState = true;
}, 800);

function loadState ({state}) {
    canSaveState = false;
    debouncedCanSaveState();

    let store = window.imageEditor.store;
    let canvas = window.imageEditor.store.canvas;

    store.mask_type = state.store.mask_type;
    window.imageEditor.maskService.updateMask();

    canvas.loadFromJSON(state.canvasData, function () {
        store.maskData = state.store.maskData;

        fieldsToWatch.forEach((field) => {
            if (field === 'mask_type') return;

            store[field] = state.store[field];
        });

        window.imageEditor.materialService.setMaterial(state.store.material_id);

        window.imageEditor.refresh();
        refresh();
    });
}
